import {
	InvoiceTemplates,
	PnlGroups,
} from '@shared/utils/constants';
import { formatCurrency } from '@shared/utils/currency';
import { ensureNegative, round } from '@shared/utils/math';
import { formatPercentage } from '@shared/utils/formatPercentage';
import TemplateItem from '../TemplateItem';
import HireInvoiceItem from './HireInvoiceItem';

class HIIDemurrageAddressCommission extends HireInvoiceItem {
	static get itemType() {
		return 'demurrageAddressCommission';
	}

	constructor(id, isOriginal, params) {
		super(id, isOriginal, { fixtureCurrency: params?.fixtureCurrency });

		this.cargoId = params.cargoId;
		this.percentage = params.percentage;

		this._showTotal = true;
		this.itemTypeLabel = 'Address Commission';
		this.pnlGroup = PnlGroups.ADDRESS_COMMISSIONS;
		this.addManually = false;
		this.templateSection = TemplateItem.Sections.COMMISSIONS;

		this._fields = {};
	}

	_calculateTotal(invoiceItems) {
		const demurrage = this.getParent(invoiceItems);
		const demurrageTotal = demurrage.getRawTotal(invoiceItems);

		const total = demurrageTotal * (this.percentage / 100);

		return round(-1 * total, 2);
	}

	getDescription() {
		return `${formatPercentage(this.percentage, 2)}`;
	}

	static async _getClassParams(model, _parentModel) {
		const cargo = await model.getCargo();

		return {
			percentage: model.percentage ?? cargo.addressCommission,
			cargoId: cargo.id,
		};
	}

	async saveModel(model) {
		await super.saveModel(model);
		model.cargoId = this.cargoId;
		model.percentage = this.percentage;
		await model.save();
	}

	_getTemplateItemParams(invoiceItems) {
		const demurrage = this.getParent(invoiceItems);

		return {
			[InvoiceTemplates.CLASSIC]: {
				columns: ['Address commission', `${this.getDescription()}`],
			},
			[InvoiceTemplates.NEO]: {
				columns: [
					' — Address commission',
					`${formatPercentage(this.percentage, 2, false)}`,
					'%',
					`${formatCurrency(
						ensureNegative(demurrage.getTotal(invoiceItems)),
						this.fixtureCurrency,
						{ hideSymbol: true },
					)}`,
				],
			},
		};
	}
}

HireInvoiceItem.addItemClass(HIIDemurrageAddressCommission);

export default HIIDemurrageAddressCommission;

